// extracted by mini-css-extract-plugin
module.exports = {"status":"style_status__5lxPs","pointer":"style_pointer__jyAE4"};